<template>
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="col">
          <h5>Wydatki 
          <router-link class="btn btn-circle torre-red" :to="{ name: 'expensesNew' }" title="Dodaj wydatek">
            <i class="material-icons" >
            add
            </i>
          </router-link>
          </h5>
        </div>
      </div>
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="">
            <div class="input-group-sm mb-2">
              <input class="form-control" @keyup="onTextChanged" v-model="form.search"/>
            </div>
          </th>
          <th class="align-top">
            <div class="input-group-sm align-top mb-2">
              <label >Data</label>
            </div>
          </th>
          <th class="align-top">
            <div class="input-group-sm align-top mb-2">
              <label >Kwota</label>
            </div>
          </th>
          <th v-if="isAdmin" class="align-top">
            <div class="input-group-sm align-top mb-2">
              <select @change="reloadContent()" class="form-control" v-model="form.selectedStoreId">
                <option v-for="option in stores" :key="option.id" v-bind:value="option.id">
                    {{ option.name }}
                </option>
              </select>
            </div>
          </th>
          <th class="align-top">
            <div class="input-group-sm align-top mb-2">
              <label >Pracownik</label>
            </div>
          </th>
          <th class="align-top">
            <div class="input-group-sm align-top mb-2">
              <label >Edycja</label>
            </div>
          </th>
          <th class="align-top">
            <div class="input-group-sm align-top mb-2">
              <label >Usuń</label>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in expenses" :key="item.id">
          <td>{{ item.expenseName }}</td>
          <td>{{ formatDate(item.expenseDate) }}</td>
          <td>{{ formatPrice(item.expensePrice) }}</td>
          <td v-if="isAdmin">{{ item.storeName }}</td>
          <td>{{ item.createdBy }}</td>

          <td v-if="canEdit(item)"><router-link :to="{ name: 'expensesEdit', params: { id: item.id} }">edytuj</router-link></td>
          <td v-else><a class="not-active" href="#">edytuj</a></td>

          <td v-if="canDelete(item)"><button class="btn btn-dark btn-sm" @click="deleteItem(item)">usuń</button></td>
          <td v-else><button class="btn btn-dark btn-sm disabled" disabled>usuń</button></td>

        </tr>
      </tbody>
    </table>
    <div v-if="showEmptyResult" class="row">
      <div class="col text-center">
        Brak wyników
      </div>
    </div>
    <common-pagination @paginationClicked="onPaginationClicked"/>
  </div>
</template>
<script>

import alertify from 'alertifyjs';
import un from 'underscore'
import ExpensesService from "@/components/expenses/ExpensesService"
import Formatter from "@/service/Formatter"

const expensesService = new ExpensesService()
const formatter = new Formatter()

export default {
    name: "ExpensesList",
    data: function () {
    return {
      stores: [],
      pageable: {
          page: 0
      },
      loading: false,
      expenses: [],
      form: {
        selectedStoreId: -1,
        search: ""
      }
    }
  },
  computed: {
    showEmptyResult() {
      return this.loading === false && this.expenses.length === 0
    },
    isAdmin() {
      return expensesService.isAdmin()
    }
  },
  created() {
    this.initStoresOptions()
  },
  methods: {
    formatPrice(price) {
        return formatter.price.ZL(price)
    },
    formatDate(expenseDate) {
        return formatter.date.YMD(expenseDate)
    },
    canEdit(item) {
      return expensesService.canEdit(item)
    },
    canDelete(item) {
      return expensesService.canDelete(item)
    },
    deleteItem(item) {
      const that = this
      alertify.confirm('', `Chcesz usunąć wydatek '${item.expenseName}'?`, function(){
          expensesService.delete(item.id, that.onDeleteSuccess, that.onDeleteError)
        }, function(){},
      );
    },
    onDeleteSuccess() {
      alertify.set('notifier','position', 'top-center');
      alertify.success("Wydatek został usunięty").delay(3);
      this.reloadContent()
    },
    onDeleteError(err) {
      console.log(err)
      alertify.set('notifier','position', 'top-center');
      alertify.error("Nie można usunąć wydatku.").delay(3);
    },
    onTextChanged: un.debounce(function (e) {
      this.pageable.page = 0;
      this.reloadContent();
    }, 300),
    initStoresOptions() {
        expensesService.initStores(this.onStoresSuccess, this.onStoresError)
    },
    onStoresSuccess(data, selectedStoreId) {
        this.stores = this.initStores(data)
        this.form.selectedStoreId = selectedStoreId
        this.reloadContent();
    },
    initStores(options) {
        const finalList = []
        if (this.isAdmin) {
            const defaultOption = {
                id: "0",
                name: "wszystkie"
            }
            finalList.push(defaultOption)
        }
        for (var i in options) {
            var item = options[i]
            finalList.push({
                id: item.id,
                name: item.name
            })
        }
        return finalList
    },
    onStoresError(err) {
        console.log(err)
    },
    reloadContent() {
        const requestData = {
            params: this.form,
            pageable: this.pageable
        }
        this.loading = true
        expensesService.search(requestData, this.onSearchSuccess, this.onSearchError)
    },
    onSearchSuccess(data) {
        this.loading = false
        this.expenses = data.items
        this.$emit('dataChanged', {
          data: data
        });
    },
    onSearchError(err) {
        this.loading = false
        console.log(err)
    },
    onPaginationClicked(payload) {
        var pageToSend = payload.pageToSend;
        this.pageable.page = pageToSend;
        this.reloadContent();
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/expenses/ExpensesList.vue